
// import React, { useState, useEffect, use } from "react";
// import ChatBot from "react-simple-chatbot";
// import chatIcon from "../assets/images/chat.png";
// import chatjson from "../json/chat";

// const MyChatbot = () => {
//     const [showChat, setShowChat] = useState(false);
//     const [chatbotdata, setChatbotdata] = useState([])

//     // Prevent multiple re-renders by keeping `steps` static
//     const chatSteps = React.useMemo(() => chatjson.steps, []);

//     useEffect(()=>{
//         setChatbotdata(chatjson.steps)
//     },[])

//     const handleEnd = ({ steps, values }) => {
//         console.log("Chat ended", steps, values);
//     };

//     return (
//         <>
//             <div className="chat-icon-box" onClick={() => setShowChat(!showChat)}>
//                 <img src={chatIcon} alt="Chat Icon" className="chat-icon" />
//             </div>
//             {showChat && (
//                 <div className="chat-box">
//                     <div className="chat-header">
//                         <h5>Chat</h5>
//                         <button className="close-btn" onClick={() => setShowChat(false)}>×</button>
//                     </div>
//                     <ChatBot
//                       key={showChat}
//                      steps={chatSteps || []} 
//                      hideOptions={true} // ✅ Ensure karega ki options hide na ho
//                      enableSmoothScroll={true}
//                      handleEnd={handleEnd} // Ensure chat persistence
//                      userDelay={500}
//                      botDelay={800}
//                     // cache={true}
//                     //  cache={true} // ✅ Chat state ko store karega
//                     //  cacheName="myChatCache"  // Local storage me store karne ke liye
//                      />
//                 </div>
//             )}
//         </>
//     );
// };

// export default MyChatbot;








// import React, { useState, useEffect } from "react";
// import ChatBot from "react-simple-chatbot";
// import chatIcon from "../assets/images/chat.png";
// import chatjson from "../json/chat";

// const Options = ({ options, triggerNextStep }) => {
//     const handleClick = (option) => {
//         console.log("✅ User Selected:", option);

//         triggerNextStep({
//             value: option.label,
//             trigger: `${option.trigger}_user`, // ✅ Pehle user ka message dikhao
//             metadata: { isUser: true } // ✅ Ensure user metadata is set
//         });

//         console.log("📌 Triggered Next Step:", `${option.trigger}_user`);
//     };


//     return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//         {options.map((option, index) => (
//             <button
//                 key={index}
//                 onClick={() => handleClick(option)}
//                 style={{
//                     margin: "5px",
//                     padding: "8px 12px",
//                     borderRadius: "5px",
//                     border: "1px solid #ccc",
//                     cursor: "pointer",
//                     backgroundColor: "#fff",
//                     color: "#000",
//                     textAlign: "left",
//                     width: "100%",
//                 }}
//             >
//                 {option.label}
//             </button>
//         ))}
//         </div>
//     );
// };


// const CustomMessage = ({ previousStep }) => {
//     console.log("🔴 CustomMessage CHECKPOINT - Render Start");

//     if (!previousStep || !previousStep.message) {
//         console.warn("❌ CustomMessage Skipped: previousStep missing", previousStep);
//         return null;
//     }

//     console.log("✅ CustomMessage Rendered with Data:", previousStep);

//     return <div>{previousStep.message}</div>;
// };


// const MyChatbot = () => {
//     const [showChat, setShowChat] = useState(false);
//     const [chatbotdata, setChatbotdata] = useState([]);

//     useEffect(() => {
//         const updatedSteps = [];

//         chatjson.steps.forEach((step) => {
//             if (step.options) {
//                 step.options.forEach((option) => {
//                     console.log(`✅ Adding user-selected message: ${option.label}`);

//                     updatedSteps.push({
//                         id: `${option.trigger}_user`,
//                         message: option.label,
//                         metadata: { isUser: true },
//                         trigger: option.trigger, // ✅ Next bot response trigger karega
//                         component: <CustomMessage previousStep={{ message: option.label, metadata: { isUser: true } }} />
//                     });

//                     const botStep = chatjson.steps.find(s => s.id === option.trigger);
//                     const botResponse = botStep?.message || "👀 Message not found! Please check JSON.";

//                     console.log(`🤖 Adding bot response: ${botResponse}`);

//                     if (botStep) {
//                         updatedSteps.push({
//                             id: option.trigger,
//                             message: botResponse,
//                             component: <CustomMessage previousStep={{ message: botResponse, metadata: { isUser: false } }} />
//                         });
//                     }
//                 });

//                 updatedSteps.push({
//                     ...step,
//                     component: <Options options={step.options} triggerNextStep={step.triggerNextStep} />,
//                     options: undefined,
//                 });

//             } else {
//                 console.log(`🤖 Adding normal bot message: ${step.message || "undefined"}`);

//                 updatedSteps.push({
//                     ...step,
//                     component: <CustomMessage previousStep={{ message: step.message, metadata: { isUser: false } }} />,
//                 });
//             }
//         });

//         console.log("📌 Final Updated Steps: ", updatedSteps);
//         setChatbotdata(updatedSteps);
//     }, []);

//     return (
//         <>
//             <div className="chat-icon-box" onClick={() => setShowChat(!showChat)}>
//                 <img src={chatIcon} alt="Chat Icon" className="chat-icon" />
//             </div>
//             {showChat && (
//                 <div className="chat-box">
//                     <div className="chat-header">
//                         <h5>Chat</h5>
//                         <button className="close-btn" onClick={() => setShowChat(false)}>×</button>
//                     </div>
//                     <ChatBot
//                         key={showChat}
//                         steps={chatbotdata || []}
//                         enableSmoothScroll={true}
//                         userDelay={500}
//                         botDelay={800}
//                         cacheName="myChatCache"
//                     />
//                 </div>
//             )}
//         </>
//     );
// };

// export default MyChatbot;






// import React, { useState, useEffect } from "react";
// import ChatBot from "react-simple-chatbot";
// import chatIcon from "../assets/images/chat.png";
// import chatjson from "../json/chat";

// const Options = ({ options, triggerNextStep }) => {
//     const [selectedOption, setSelectedOption] = useState(null);

//     const handleClick = (option) => {
//         console.log("Selected Option:", option);
//         setSelectedOption(option); // ✅ Store selected option
//     };
//     return (
//         <div style={{ display: "flex", flexDirection: "column" }}>
//             {options.map((option, index) => (
//                 <button
//                     key={index}
//                     onClick={() => handleClick(option)}
//                     style={{
//                         margin: "5px",
//                         padding: "8px 12px",
//                         borderRadius: "5px",
//                         border: "1px solid #ccc",
//                         cursor: "pointer",
//                         backgroundColor: selectedOption?.label === option.label ? "#d3d3d3" : "#fff",
//                         color: "#000",
//                         textAlign: "left",
//                         width: "100%",
//                     }}
//                 >
//                     {option.label}
//                 </button>
//             ))}

//             {/* ✅ Only show the confirm button AFTER an option is selected */}
//             {selectedOption && (
//                 <button
//                     onClick={() => {
//                         triggerNextStep({
//                             value: selectedOption.label,
//                             trigger: selectedOption.trigger,
//                         });
//                     }}
//                     style={{
//                         marginTop: "10px",
//                         padding: "8px 12px",
//                         borderRadius: "5px",
//                         border: "none",
//                         cursor: "pointer",
//                         backgroundColor: "#007bff",
//                         color: "#fff",
//                         textAlign: "center",
//                         width: "100%",
//                     }}
//                 >
//                     Confirm Selection
//                 </button>
//             )}
//         </div>
//     );
// };

// const CustomMessage = ({ previousStep }) => {
//     if (!previousStep || !previousStep.message) {
//         return null;
//     }
//     return <div>{previousStep.message}</div>;
// };

// const MyChatbot = () => {
//     const [showChat, setShowChat] = useState(false);
//     const [chatbotdata, setChatbotdata] = useState([]);

//     useEffect(() => {
//         const updatedSteps = chatjson.steps.map((step) => {
//             if (step.options) {
//                 return {
//                     ...step,
//                     component: (props) => (
//                         <Options options={step.options} triggerNextStep={props.triggerNextStep} />
//                     ),
//                 };
//             }
//             return {
//                 ...step,
//                 component: (props) => <CustomMessage previousStep={props.previousStep} />,
//             };
//         });

//         setChatbotdata(updatedSteps);
//     }, []);

//     return (
//         <>
//             <div className="chat-icon-box" onClick={() => setShowChat(!showChat)}>
//                 <img src={chatIcon} alt="Chat Icon" className="chat-icon" />
//             </div>
//             {showChat && (
//                 <div className="chat-box">
//                     <div className="chat-header">
//                         <h5>Chat</h5>
//                         <button className="close-btn" onClick={() => setShowChat(false)}>×</button>
//                     </div>
//                     <ChatBot
//                         key={showChat}
//                         steps={chatbotdata || []}
//                         enableSmoothScroll={true}
//                         userDelay={500}
//                         botDelay={800}
//                         cacheName="myChatCache"
//                     />
//                 </div>
//             )}
//         </>
//     );
// };

// export default MyChatbot;








import React, { useState, useEffect, useRef } from "react";
import ChatBubble from "./ChatBubble";
import MessageInput from "./MessageInput";
import chatData from "../pages/DeveloperDocuments/json/chat.json";
import chatIcon from "../assets/images/chat.png";
import { useLocation } from "react-router-dom";
import logo from "../assets/images/logo4.png";
import { FaMinus } from "react-icons/fa";
import i18next from 'i18next';

const ChatWindow = () => {
    const pathlocation = useLocation();
    const [RemoveIcon, setRemoveIcon] = useState(true);
    const [allLanguage, setAllLanguage] = useState("english");

    // Set language according current local
    useEffect(() => {
        i18next.changeLanguage(navigator.language === 'en-US' ? 'en' : 'fr'); // Change the i18next language
        localStorage.setItem("handleSelectedLanguage", navigator.language === 'en-US' ? 'english' : 'guinea');
    }, [navigator.language]);

    // Get handleSelectedLanguage from localStorage
    useEffect(() => {
        const storeHandleSelectedLanguage = localStorage.getItem('handleSelectedLanguage');
        if (storeHandleSelectedLanguage) {
            setAllLanguage(storeHandleSelectedLanguage); // Update state
        }
    }, [localStorage.getItem('handleSelectedLanguage')]); // Runs only on mount

    useEffect(() => {
        if (
            pathlocation.pathname === "/login" ||
            pathlocation.pathname === "/signup" ||
            pathlocation.pathname === "/forget-password" ||
            pathlocation.pathname === "/reset-password"
        ) {
            setRemoveIcon(false);
        } else {
            setRemoveIcon(true);
        }
    }, [pathlocation]);

    const [showChat, setShowChat] = useState(false);
    const [messages, setMessages] = useState([]);
    const [currentStep, setCurrentStep] = useState("1");
    const [isLoading, setIsLoading] = useState(false);
    const [adminMode, setAdminMode] = useState(false);
    const [userInfo, setUserInfo] = useState({ name: "", email: "" });
    const [collectingInfoStep, setCollectingInfoStep] = useState("name");
    const [emailError, setEmailError] = useState("");
    const [selectedOptionId, setSelectedOptionId] = useState(null);

    const chatRef = useRef(null);

    useEffect(() => {
        if (!chatData || !chatData[allLanguage === "english" ? 'en' : 'fr'].steps) return;
        const step = chatData[allLanguage === "english" ? 'en' : 'fr'].steps.find((s) => s.id === currentStep);
        if (step?.message && !adminMode) {
            setIsLoading(true);
            setTimeout(() => {
                setMessages((prev) => [
                    ...prev,
                    {
                        text: step.message,
                        isUser: false,
                        options: step.options || [],
                        sender: "bot",
                    },
                ]);
                setIsLoading(false);
            }, 1000);
        }
    }, [currentStep, adminMode]);

    // ✅ NEW: Auto-trigger next step if current step has no options but has a trigger
    useEffect(() => {
        const step = chatData[allLanguage === "english" ? 'en' : 'fr'].steps.find((s) => s.id === currentStep);
        if (adminMode || !step) return;

        if ((!step.options || step.options.length === 0) && step.trigger) {
            setTimeout(() => {
                setCurrentStep(step.trigger);
            }, 1500);
        }
    }, [currentStep, adminMode]);

    const handleOptionClick = (option) => {
        setSelectedOptionId(option.id);
        setMessages((prev) => [
            ...prev,
            { text: option.label, isUser: true, sender: "user" },
        ]);

        if (option.trigger === "admin") {
            startAdminChat();
        } else {
            setCurrentStep(option.trigger);
        }
    };

    const handleSend = (text) => {
        if (!adminMode) {
            setMessages((prev) => [...prev, { text, isUser: true, sender: "user" }]);
            return;
        }

        if (!userInfo.name || !userInfo.email) {
            if (collectingInfoStep === "name") {
                setUserInfo((prev) => ({ ...prev, name: text }));
                setMessages((prev) => [
                    ...prev,
                    { text, isUser: true, sender: "user" },
                    {
                        text: "Thanks! What's your email address?",
                        isUser: false,
                        sender: "admin",
                    },
                ]);
                setCollectingInfoStep("email");
            } else {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(text)) {
                    setEmailError("That email doesn’t look quite right");
                    return;
                }
                setEmailError("");
                setUserInfo((prev) => ({ ...prev, email: text }));
                setMessages((prev) => [
                    ...prev,
                    { text, isUser: true, sender: "user" },
                    {
                        text: "Great, thank you! Now, please describe your problem.",
                        isUser: false,
                        sender: "admin",
                    },
                ]);
            }
        } else {
            setMessages((prev) => [
                ...prev,
                { text, isUser: true, sender: "user" },
            ]);
            setTimeout(() => {
                setMessages((prev) => [
                    ...prev,
                    {
                        text: "Hii! By the way, if you need help with our products, you can also check our FAQ section anytime!",
                        isUser: false,
                        sender: "bot",
                    },
                ]);
            }, 1000);
        }
    };

    useEffect(() => {
        if (chatRef.current) {
            chatRef.current.scrollTop = chatRef.current.scrollHeight;
        }
    }, [messages, isLoading, emailError]);

    const startAdminChat = () => {
        setAdminMode(true);
        setMessages((prev) => [
            ...prev,
            {
                text: "First of all, what's your name?",
                isUser: false,
                sender: "admin",
            },
        ]);
        setCollectingInfoStep("name");
    };

    return (
        <>
            {RemoveIcon && (
                <div className="chat-icon-box" onClick={() => setShowChat(!showChat)}>
                    <img src={chatIcon} alt="Chat Icon" className="chat-icon" />
                </div>
            )}

            {showChat && (
                <div className="chat-box">
                    <div className="chat-header">
                        <div>
                            <img src={logo} className="chat-logo" alt="Logo" />
                        </div>
                        <button className="close-btn" onClick={() => setShowChat(false)}>
                            <FaMinus />
                        </button>
                    </div>

                    <div
                        className="chat-body"
                        ref={chatRef}
                        style={{
                            flex: 1,
                            padding: "10px",
                            overflowY: "auto",
                            background: "#f5f5f5",
                        }}
                    >
                        {messages.map((msg, i) => (
                            <div key={i}>
                                <ChatBubble text={msg.text} isUser={msg.isUser} sender={msg.sender} />
                                {msg.options?.length > 0 && (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "6px",
                                            marginTop: "10px",
                                        }}
                                    >
                                        {msg.options.map((opt, idx) => (
                                            <button
                                                key={idx}
                                                onClick={() => handleOptionClick(opt)}
                                                style={{
                                                    padding: "8px 12px",
                                                    borderRadius: "5px",
                                                    border: "1px solid #ccc",
                                                    cursor: "pointer",
                                                    backgroundColor:
                                                        selectedOptionId === opt.id ? "#3a4857" : "#fff",
                                                    color: selectedOptionId === opt.id ? "#fff" : "#000",
                                                    textAlign: "left",
                                                    fontSize: "12px",
                                                    fontWeight: "400"
                                                }}
                                            >
                                                {opt.label}
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}

                        {emailError && (
                            <div style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>
                                {emailError}
                            </div>
                        )}

                        {isLoading && (
                            <div style={{ padding: "10px" }}>
                                <div className="typing-loader">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        )}
                    </div>
                    <MessageInput onSend={handleSend} />
                </div>
            )}
        </>
    );
};

export default ChatWindow;








// import React, { useState, useEffect, useRef } from "react";
// import ChatBubble from "./ChatBubble";
// import MessageInput from "./MessageInput";
// import chatData from "../json/chat.json";
// import chatIcon from "../assets/images/chat.png";

// const ChatWindow = () => {
//     const [showChat, setShowChat] = useState(true);
//     const [messages, setMessages] = useState([]);
//     const [currentStep, setCurrentStep] = useState("1");
//     const [isLoading, setIsLoading] = useState(false);
//     const [adminMode, setAdminMode] = useState(false);
//     const [adminInfo, setAdminInfo] = useState({ name: "", email: "" });
//     const [adminReady, setAdminReady] = useState(false);

//     const chatRef = useRef(null);

//     useEffect(() => {
//         if (!adminMode) {
//             const step = chatData.steps.find((s) => s.id === currentStep);
//             if (step?.message) {
//                 setIsLoading(true);
//                 setTimeout(() => {
//                     setMessages((prev) => [
//                         ...prev,
//                         {
//                             text: step.message,
//                             sender: "bot",
//                             isUser: false,
//                             options: step.options || [],
//                         },
//                     ]);
//                     setIsLoading(false);
//                 }, 1000);
//             }
//         }
//     }, [currentStep, adminMode]);

//     const handleOptionClick = (option) => {
//         setMessages((prev) => [
//             ...prev,
//             { text: option.label, sender: "user", isUser: true },
//         ]);
//         setCurrentStep(option.trigger);
//     };

//     const handleSend = (text) => {
//         const sender = adminMode ? "admin" : "user";
//         setMessages((prev) => [
//             ...prev,
//             { text, sender, isUser: sender === "user" },
//         ]);

//         if (!adminMode) {
//             // Trigger next bot response
//             const current = chatData.steps.find((s) => s.id === currentStep);
//             const nextId = current?.options?.find(opt => opt.label === text)?.trigger;
//             if (nextId) setCurrentStep(nextId);
//         }
//     };

//     useEffect(() => {
//         if (chatRef.current) {
//             chatRef.current.scrollTop = chatRef.current.scrollHeight;
//         }
//     }, [messages, isLoading]);

//     const handleAdminFormSubmit = (e) => {
//         e.preventDefault();
//         if (adminInfo.name && adminInfo.email) {
//             setAdminReady(true);
//         }
//     };

//     return (
//         <>
//             {showChat && (
//                 <div className="chat-box">
//                     <div className="chat-header">
//                         <h5>Chat</h5>
//                     </div>
//                     <div
//                         className="chat-body"
//                         ref={chatRef}
//                         style={{
//                             flex: 1,
//                             padding: "10px",
//                             overflowY: "auto",
//                             background: "#f5f5f5",
//                         }}
//                     >
//                         {messages.map((msg, i) => (
//                             <div key={i}>
//                                 <ChatBubble text={msg.text} isUser={msg.isUser} sender={msg.sender} />
//                                 {msg.options?.length > 0 && msg.sender === "bot" && (
//                                     <div style={{ display: "flex", flexDirection: "column", gap: "6px", marginTop: "10px" }}>
//                                         {msg.options.map((opt, idx) => (
//                                             <button
//                                                 key={idx}
//                                                 onClick={() => handleOptionClick(opt)}
//                                                 style={{
//                                                     padding: "8px 12px",
//                                                     borderRadius: "5px",
//                                                     border: "1px solid #ccc",
//                                                     cursor: "pointer",
//                                                     backgroundColor: "#fff",
//                                                     textAlign: "left",
//                                                 }}
//                                             >
//                                                 {opt.label}
//                                             </button>
//                                         ))}
//                                     </div>
//                                 )}


//                                 <div className="button-box">
//                                     <div>
//                                         <button onClick={() => setAdminMode(true)}>Admin</button>
//                                     </div>
//                                 </div>

//                                 {adminMode === "true" ?
//                                     <>
//                                         <form onSubmit={handleAdminFormSubmit} style={{ padding: 10 }}>
//                                             <input
//                                                 type="text"
//                                                 placeholder="Admin Name"
//                                                 value={adminInfo.name}
//                                                 onChange={(e) => setAdminInfo({ ...adminInfo, name: e.target.value })}
//                                                 required
//                                             />
//                                             <input
//                                                 type="email"
//                                                 placeholder="Admin Email"
//                                                 value={adminInfo.email}
//                                                 onChange={(e) => setAdminInfo({ ...adminInfo, email: e.target.value })}
//                                                 required
//                                             />
//                                             <button type="submit">Send</button>
//                                         </form>
//                                     </> :
//                                     <>
//                                         <ChatBubble isUser={msg.isUser} sender={msg.sender} />
//                                     </>}


//                             </div>
//                         ))}
//                         {isLoading && (
//                             <div style={{ padding: "10px" }}>
//                                 <div className="typing-loader1">
//                                     <span></span><span></span><span></span>
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                     <MessageInput onSend={handleSend} />

//                 </div>
//             )}
//         </>
//     );
// };

// export default ChatWindow;








